import { AnalysisDocument } from "src/app/common/models/analysis-document.model";
import { TaggingStatus } from "src/app/config";
import { deserializeToSpeechSegment, SpeechSegment } from "src/app/modules/speech2text/models/speech-segment.model";

export const speakerGlobalId = "global";

export type Speech2TextType = "AUDIO" | "VIDEO";

export interface Speech2Text extends AnalysisDocument {
  segments: SpeechSegment[];
  summary: string;
  taggingStatus: TaggingStatus;
  availableLanguages: string[];
  mediaUrl?: string;
  urn?: string;
  collectionId?: string;
  mediaSystemId?: string;
  errorMessage?: string;
  speech2TextType?: Speech2TextType;
  createdDate?: Date;
}

export const deserializeToSpeech2Text = (input: Partial<Speech2Text>): Speech2Text => {
  const partialSpeech2Text: Partial<Speech2Text> = {
    ...input,
    iptcTagRefs: input.iptcTagRefs ?? [],
    entityRefs: input.entityRefs ?? [],
    segments: input.segments?.map((segment) => deserializeToSpeechSegment(segment)) ?? [],
    taggingStatus: input.taggingStatus || (input.body ? "TO_BE_TAGGED" : "NO_STATUS"),
  };
  return partialSpeech2Text as Speech2Text;
};
